var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass:
        "d-flex justify-space-between userblock-container items-center pt-2"
    },
    [
      _c(
        "div",
        {
          staticClass: "search-wrapper"
        },
        [_c("HostingSearch")],
        1
      ),
      _c(
        "div",
        {
          staticClass: "d-flex flex-row gap-4"
        },
        [
          _c(
            "div",
            {
              staticClass: "pr-8"
            },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    icon: ""
                  },
                  on: {
                    click: function click($event) {
                      return _vm.$router.push("/support")
                    }
                  }
                },
                [_c("v-icon", [_vm._v("mdi-help-circle-outline")])],
                1
              ),
              _c("notifications")
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "v-menu",
                {
                  attrs: {
                    bottom: "",
                    "offset-y": "",
                    left: "",
                    attach: "#user-menu",
                    "content-class": "userblock-dropdown",
                    "disable-keys": "",
                    "nudge-top": "-10",
                    "nudge-right": "0",
                    transition: "slide-y-transition",
                    "min-width": "225",
                    "close-on-content-click": false
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function fn(_ref) {
                        var on = _ref.on
                        return [
                          _c(
                            "div",
                            _vm._g(
                              {
                                on: {
                                  click: _vm.requestToken
                                }
                              },
                              on
                            ),
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "display-ib pr-2 v-align--bottom text-right cursor-pointer"
                                },
                                [
                                  _c("span", {
                                    staticClass: "fs-14 d-block",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.userName)
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "fs-12 fw-light d-block"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.SessionProfile.email) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "v-avatar",
                                {
                                  staticClass: "cursor-pointer",
                                  attrs: {
                                    size: "42"
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.SessionProfile.gravatar,
                                      alt: "avatar"
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    "aria-label": "Profile menu",
                                    ripple: false,
                                    plain: ""
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "cursor-pointer"
                                    },
                                    [_vm._v("mdi-chevron-down")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.menu,
                    callback: function callback($$v) {
                      _vm.menu = $$v
                    },
                    expression: "menu"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-content"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-top white--text text-right"
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "white--text fs-14 font-weight-medium d-block"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.SessionProfile.firstname) +
                                  " " +
                                  _vm._s(_vm.SessionProfile.lastname) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "d-block fs-12 fw-light"
                            },
                            [_vm._v(_vm._s(_vm.SessionProfile.email))]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "d-block fs-14 fw-light"
                            },
                            [
                              _vm._v(" Customer ID: "),
                              _c(
                                "b",
                                {
                                  staticClass: "font-weight-medium"
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.SessionProfile.accountId)
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "d-block fs-14 fw-light"
                            },
                            [
                              _vm._v(" Support PIN: "),
                              _vm.loadingSupportToken
                                ? _c("v-progress-circular", {
                                    staticClass: "mx-2",
                                    attrs: {
                                      indeterminate: "",
                                      size: "14",
                                      width: "2",
                                      color: "white"
                                    }
                                  })
                                : [
                                    _c(
                                      "b",
                                      {
                                        staticClass: "font-weight-medium"
                                      },
                                      [_vm._v(" " + _vm._s(_vm.supportToken))]
                                    )
                                  ],
                              _c(
                                "gg-btn",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        !_vm.supportToken &&
                                        !_vm.loadingSupportToken,
                                      expression:
                                        "!supportToken && !loadingSupportToken"
                                    }
                                  ],
                                  attrs: {
                                    color: "white",
                                    text: ""
                                  },
                                  on: {
                                    click: function click($event) {
                                      $event.stopPropagation()
                                      return _vm.requestToken($event)
                                    }
                                  }
                                },
                                [_vm._v(" Request ")]
                              )
                            ],
                            2
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "text-right",
                              attrs: {
                                "aria-hidden": "true"
                              }
                            },
                            [
                              _c("v-switch", {
                                staticClass:
                                  "theme-switcher mt-1 d-inline-block",
                                attrs: {
                                  tabindex: "-1",
                                  color: "white",
                                  "hide-details": "",
                                  label: "Dark Mode"
                                },
                                on: {
                                  change: function change($event) {
                                    return _vm.switchTheme(false)
                                  }
                                },
                                model: {
                                  value: _vm.$vuetify.theme.dark,
                                  callback: function callback($$v) {
                                    _vm.$set(_vm.$vuetify.theme, "dark", $$v)
                                  },
                                  expression: "$vuetify.theme.dark"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "v-list dropdown-list user-menu"
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "user-menu-item pa-4 ma-1 d-flex",
                              attrs: {
                                to: {
                                  name: "profile_info"
                                },
                                tabindex: "0"
                              },
                              nativeOn: {
                                click: function click($event) {
                                  return _vm.closeMenu($event)
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-3 primary--text",
                                  attrs: {
                                    small: ""
                                  }
                                },
                                [_vm._v("mdi-account")]
                              ),
                              _c(
                                "span",
                                {
                                  class: {
                                    "black--text": !_vm.isDarkTheme
                                  }
                                },
                                [_vm._v("My Profile")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "router-link",
                            {
                              staticClass:
                                "user-menu-item user-menu-item pa-4 ma-1 d-flex",
                              attrs: {
                                to: {
                                  name: "billing"
                                },
                                tabindex: "0"
                              },
                              nativeOn: {
                                click: function click($event) {
                                  return _vm.closeMenu($event)
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-3 primary--text",
                                  attrs: {
                                    small: ""
                                  }
                                },
                                [_vm._v("mdi-currency-usd")]
                              ),
                              _c(
                                "span",
                                {
                                  class: {
                                    "black--text": !_vm.isDarkTheme
                                  }
                                },
                                [_vm._v("Billing")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "a",
                            {
                              staticClass:
                                "user-menu-item user-menu-item pa-4 ma-1 d-flex",
                              attrs: {
                                href: "#",
                                tabindex: "0"
                              },
                              on: {
                                click: function click($event) {
                                  $event.stopPropagation()
                                  return _vm.logOut($event)
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-3 primary--text",
                                  attrs: {
                                    small: ""
                                  }
                                },
                                [_vm._v("mdi-power")]
                              ),
                              _c(
                                "span",
                                {
                                  class: {
                                    "black--text": !_vm.isDarkTheme
                                  }
                                },
                                [_vm._v("Logout")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              ),
              _c("div", {
                attrs: {
                  id: "user-menu"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "navbar-switcher"
            },
            [
              _c(
                "gg-btn",
                {
                  staticClass: "pl-0 ml-0 d-flex d-lg-none",
                  attrs: {
                    icon: ""
                  },
                  on: {
                    click: function click($event) {
                      $event.stopPropagation()
                      _vm.drawer = !_vm.drawer
                    }
                  }
                },
                [_c("v-icon", [_vm._v("mdi-menu")])],
                1
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }